import React from 'react'
import { Grid } from '@mui/material'

const SingleOrgContainer = () => (
  <Grid container flexDirection="column">
    Single Org Settings Container Placeholder
  </Grid>
)

export default SingleOrgContainer
